/*
 * Copyright Deskshare, Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { RouteObject } from "react-router-dom";

export const createLocalizeRouter = (routes: RouteObject[]) => {
  const adapter = (route: RouteObject) => {
    if (route.path && route.path !== "/") {
      const path = "/:lang" + route.path;
      route.path = path;
    }
    if (!route.children || route.children.length === 0) return route;
    route.children = route.children.map((child: RouteObject) => adapter(child));
    return route;
  };
  return routes.map((route) => adapter(route));
};
